// Retourne les classes CSS utilisées pour l'espacement entre les blocs
export const getClassesFromMarginsProp = (marginArray) => {
  if (typeof marginArray === 'undefined') return ''

  let topMargin = marginArray[0]
  let bottomMargin = marginArray[1]
  let topLargeMargin = marginArray[2]
  let bottomLargeMargin = marginArray[3]

  switch (marginArray.length) {
    case 4:
      return `mt-${topMargin} mb-${bottomMargin} 💻mt-${topLargeMargin} 💻mb-${bottomLargeMargin}`
    case 3:
      return `mt-${topMargin} mb-${bottomMargin} 💻mt-${topLargeMargin} 💻mb-${bottomMargin}`
    case 2:
      return `mt-${topMargin} mb-${bottomMargin} 💻mt-${topMargin} 💻mb-${bottomMargin}`
    default:
      return `mt-${topMargin} mb-0 💻mt-${topMargin} 💻mb-0`
  }
}

// Retourne les classes CSS utilisées pour le style de titre
export const getClassesFromTitleStyleProp = (titleStyle) => {
  if (typeof titleStyle === 'undefined') return 'title-style-1'

  return `title-style-${titleStyle}`
}

// Retourne le prix mis en forme
export const getCurrencyFormat = (price) => {
  const priceFormatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: price % 1 === 0 ? 0 : 2
  })

  return priceFormatter.format(price)
}
